import "./header.css"

import header_logo from "../../../assets/general_assets/logo 2.png"
import imagem_faixa from "../../../assets/general_assets/logo1.png"
import { Link, useLocation } from "react-router-dom";
import { useCallback, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import saopaulo from "../../../assets/general_assets/saoPaulo.jpeg"
import riodejaneiro from "../../../assets/general_assets/rioDeJaneiro.png"
import skyfit from "../../../assets/general_assets/skyfit-academia-tiny-1024x363.png"
import skyfitlogo from "../../../assets/general_assets/skyfit_logo.png"
import locatelliLogo from "../../../assets/general_assets/locatelli_logo.png"
import locatelliLogoMenu from "../../../assets/general_assets/locatelliLogoFinal.jpg"

import { scrollWithOffset } from "../scrollWithOffset/index.js"

export default function Header() {

    const [isOpen, setIsOpen] = useState(false)

    //referências do ícone da aba das unidades e seção de professores 
    const UnitChoiceRef = useRef(null);
    const arrowRef = useRef(null);

    //referências dos ícones das unidades SkyFit e Locatelli
    const SKref = useRef(null)
    const LOref = useRef(null)
    const plusRef = useRef(null)

    //referências dos elementos de responsividade
    const responsiveMenu = useRef(null)
    const list_icon = useRef(null)
    const headerRef = useRef(null)

    //variável de estado, varíavel useLocation e lista dos 'paths' com uma string represando a unidade atual
    const [unidade, setUnidade] = useState('Unidade')
    const location = useLocation()
    const navigate = useNavigate()
    const Unidades = {
        "/unidadeSP": "Pompeia",
        "/unidadeRJ": "Matriz",
        "/unidadeSkyFit": "SkyFit",
        "/unidadeLocatelli": "Locatelli"
    }

    

    //função para abrir o menu das unidades
    function openUnitMenu() {

        //condição para verificar se o elemento da aba das unidades possui a classe aberto
        //inclusive o icon com a classe 'down'
        if (UnitChoiceRef.current.classList.contains("Unit_open")) {
            UnitChoiceRef.current.classList.remove("Unit_open");
            arrowRef.current.className = "bi bi-chevron-down";
            //caso verdadeiro adiciona a classe aberto para a aba, caso falso remove a classe
        } else {
            UnitChoiceRef.current.classList.add("Unit_open");
            arrowRef.current.className = "bi bi-chevron-up";
        }


    }

    // função para mostrar o menu responsivo ( valido para resoluções <= 768px )
    const showMenu = () => {

        //muda a animação do elemento responsiveMenu para abrir o menu
        responsiveMenu.current.classList.add("open");
        list_icon.current.className = "bi bi-x-lg";
        

        setIsOpen(true);
        
        //busca no documento o elemento 'overlay' para a tela ficar escura ao abrir o menu
        const overlay = document.getElementById('overlay');
        //se o overlay existir adiciona a classe para escurecer o elemento
        if (overlay) overlay.classList.add('active');
        //impossibilita a possibilidade de rolar a tela enquanto o menu estiver aberto
        document.body.classList.add('click')
    }
    
    //função para fechar o menu responsivo ( valido para resoluções <= 768px )
    const hideMenu = () => {
        //muda a animação do elemento responsiveMenu para fechar o menu
        responsiveMenu.current.classList.remove("open");
        list_icon.current.className = "bi bi-list";
        
    

        setIsOpen(false);
        
        //busca no documento o elemento 'overlay' para a tela ficar clara ao fechar o menu
        const overlay = document.getElementById('overlay');

        //se o overlay existir remove a classe para esclarecer o elemento
        if (overlay) overlay.classList.remove('active');
        //retorna a possibilidade de rolar a tela enquanto o menu estiver fechado
        document.body.classList.remove('click')
    }

    //função para fechar o menu clicando em qualquer lugar na tela, na parte escura
    const clickCloseMenu = useCallback(() => {
        
        hideMenu();
        
    }, [hideMenu, responsiveMenu, headerRef]);

    //'useEffect' para verificar dinamicamente o estado do menu responsivo, e tirar o 'EventListener'
    //quando fechado
    useEffect(() => {
        if (!showMenu) return;

        window.addEventListener('touchmove', clickCloseMenu);
        return () => {
            window.removeEventListener('touchmove', clickCloseMenu);
        };

    }, [showMenu, clickCloseMenu]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) hideMenu(); 
                
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
        
    }, [hideMenu]);

    //'useEffect' para verificar dinamicamente o estado da aba das unidades
    //trocando para o nome da unidade que foi clicada
    //deixando também por padrão o conteúdo como 'Unidades' e fechado
    useEffect(() => {


        if (UnitChoiceRef.current) {
            UnitChoiceRef.current.classList.remove("Unit_open")
        }

        if (arrowRef.current) {
            arrowRef.current.className = "bi bi-chevron-down"
        }

        if (responsiveMenu.current || responsiveMenu.current.style.animation === "showMenu .3s ease forwards") {
            responsiveMenu.current.style.animation = "hideMenu .3s ease forwards"
        }


        setUnidade(Unidades[location.pathname] || "Unidades")

        const handleScroll = () => {
            if (window.scrollY > 50) {
                UnitChoiceRef.current.classList.remove("Unit_open");
                arrowRef.current.className = "bi bi-chevron-down";
            }

        }


        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [location]);


    //'useEffect' para verificar dinamicamente se a unidade for Skyfit ou Locatelli
    //adicionar o respectivo logo ao lado do da TeamCrezio no cabeçalho
    useEffect(() => {

        if (unidade === "SkyFit") {
            SKref.current.classList.remove("hide")

        } else {
            SKref.current.classList.add("hide")

        }

        if (unidade === "Locatelli") {
            LOref.current.classList.remove("hide")

        } else {
            LOref.current.classList.add("hide")

        }

        if (unidade === "SkyFit" || unidade === "Locatelli") {
            plusRef.current.classList.remove("hide");
        } else {
            plusRef.current.classList.add("hide");

        }

    }, [unidade])

    useEffect(() => {

        const handleScroll = () => {

            const header = document.querySelector('.header');



            if (!header) return;


            if (window.scrollY > 50) {
                header.classList.add('header_animado');

            } else {
                header.classList.remove('header_animado');
            }



        };


        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);



    //uso da função 'scrollWithOffset' para os elementos que falam sobre a academia
    const academia = () => {
        const academiaHomeImg = document.getElementById("academiaHomeImg")
        hideMenu()
        scrollWithOffset(academiaHomeImg, 100)
    }

    //uso da função 'scrollWithOffset' para os elementos que falam sobre a historia da academia
    const nossaHistoria = () => {
        const nossaHistoria = document.getElementById("nossaHistoriaHomeImg")
        hideMenu()
        scrollWithOffset(nossaHistoria, 100)
    }

    const contato = () => {
        const footer = document.getElementById("footer")
        hideMenu()
        scrollWithOffset(footer, 0)
    }


    //render do header HTML e etc.
    return (
        <>
            <header ref={headerRef} class="header permitir_click">

                <div className="logo_compose">
                    <Link to="/"><img className="header_img_closed" src={header_logo} alt="logo_crezio"></img></Link>
                    <Link to="/"><img className="header_img_open" src={imagem_faixa} alt="logo_crezio"></img></Link>
                </div>
                <i id="plus" ref={plusRef} class="hide bi bi-plus"></i>

                <img ref={SKref} className="hide skyfit" src={skyfit} alt="logo_skyfit"></img>
                <img ref={LOref} className="hide skyfit" src={locatelliLogo} alt="logo_skyfit"></img>



                <nav class="info_header">
                    <div>

                        <ul class="header_options">
                            <li onClick={() => {
                                if (location.pathname === "/" || location.pathname === "") {
                                    academia()
                                } else {
                                    navigate("/", { state: { scrollTo: "academia" } })
                                    
                                }
                            }} >Academia</li>
                            <li onClick={() => {
                                if (location.pathname === "/" || location.pathname === "") {
                                    nossaHistoria()
                                    
                                } else {
                                    navigate("/", { state: { scrollTo: "nossaHistoria" } })
                                }
                            }}>Nossa História</li>
                            <Link to="https://venda.nextfit.com.br/e8b6954d-a06b-42a1-adeb-6e6b22ec5868/produtos"><li>Loja</li></Link>
                            <li onClick={contato}>Contato</li>
                            <Link to="/galeria"><li> Galeria </li></Link>
                        </ul>
                    </div>

                    <div id="hidden_menu">
                        <i onClick={() => { isOpen ? hideMenu() : showMenu()}} class="bi bi-list" ref={list_icon} id="list_icon"></i>
                        <ul ref={responsiveMenu} class="header_options hide">
                            <li onClick={() => {
                                if (location.pathname === "/" || location.pathname === "") {
                                    academia()
                                } else {
                                    navigate("/", { state: { scrollTo: "academia" } })
                                    
                                }
                            }}>Academia</li>
                            <li onClick={() => {
                                if (location.pathname === "/" || location.pathname === "") {
                                    nossaHistoria()
                                
                                } else {
                                    navigate("/", { state: { scrollTo: "nossaHistoria" } })
                                }
                            }}>Nossa História</li>
                            <Link to="https://venda.nextfit.com.br/e8b6954d-a06b-42a1-adeb-6e6b22ec5868/produtos"><li>Loja</li></Link>
                            <li onClick={contato}>Contato</li>
                            <Link to="/galeria"><li> Galeria </li></Link>
                        </ul>
                    </div>

                    <div id="UnitChoice" ref={UnitChoiceRef} className="Unit_choice ">
                        <p>{unidade} <i ref={arrowRef} onClick={openUnitMenu} className="bi bi-chevron-down"></i></p>
                        <ul className="hidden_unit Unit_choice_options">
                            <Link to="/unidadeSP"><li>Pompeia <img className="Unit_img" alt="SP" src={saopaulo} /></li></Link>
                            <Link to="/unidadeRJ"><li>Matriz <img className="Unit_img" alt="RJ" src={riodejaneiro} /> </li></Link>
                            <Link to="/unidadeSkyFit"><li>Skyfit <img className="Unit_img" alt="SF" src={skyfitlogo} /> </li></Link>
                            <Link to="/unidadeLocatelli"><li>Locatelli <img className="Unit_img" alt="LO" src={locatelliLogoMenu} /> </li></Link>
                        </ul>
                    </div>
                </nav>

                <div ref={responsiveMenu} className="hidden_menu-nav permitir_click">
                    <i onClick={hideMenu} class="bi bi-arrow-return-right"></i>
                    <ul class="hidden_menu_options permitir_click">
                        <li onClick={() => {
                            if (location.pathname === "/" || location.pathname === "") {
                                academia()
                            } else {
                                navigate("/", { state: { scrollTo: "academia" } })
                                
                            }
                        }}>Academia</li>
                        <li onClick={() => {
                            if (location.pathname === "/" || location.pathname === "") {
                                nossaHistoria()
                              
                            } else {
                                navigate("/", { state: { scrollTo: "nossaHistoria" } })
                            }
                        }}>Nossa História</li>
                        <Link to="https://venda.nextfit.com.br/e8b6954d-a06b-42a1-adeb-6e6b22ec5868/produtos"><li>Loja</li></Link>
                        <li onClick={contato}>Contato</li>
                        <Link to="/galeria"><li> Galeria </li></Link>

                    </ul>
                </div>
            </header>
        </>
    );
}